import script from "./EventView.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventView.vue?vue&type=script&lang=ts&setup=true"

import "./EventView.vue?vue&type=style&index=0&id=eca62a0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eca62a0e"]])

export default __exports__